<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MT"][arry_amt.I > 0? "EWMT": "AWMT"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol md="4">
                                        <label class="col-form-label-sm">{{getLanguage["MT"]["VIP"]}} :</label><br>
                                        <label class="switch">
                                            <input type="checkbox" :checked="arry_amt.VIPBAA" v-model="arry_amt.VIPBAA" />
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>
                                    <CCol md="4">
                                        <label class="col-form-label-sm">{{getLanguage["MT"]["VDP"]}} :</label><br>
                                        <label class="switch">
                                            <input type="checkbox" :checked="arry_amt.VDP" v-model="arry_amt.VDP" />
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol md="4">
                                        <label class="col-form-label-sm">{{this.getLanguage["MT"]["BN"]}}<span class="required" /> :</label>
                                        <customtreeselect :multiple="false"
                                                          :options="dd_agentgroup"
                                                          :flat="true"
                                                          :defaultExpandLevel="Infinity"
                                                          :clearable="false"
                                                          :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                          v-model="arry_amt['AGIT']"
                                                          :disabled="arry_amt.I > 0" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                    </CCol>
                                    <CCol md="4">
                                        <label class="col-form-label-sm">{{this.getLanguage["MT"]["MTN"]}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_mt"
                                                    :placeholder="this.utilGetDDLanguage('MT.MTN')"
                                                    :clearable="false"
                                                    @input="TypeNameChange"
                                                    v-model="arry_amt['TNI']"
                                                    :disabled="arry_amt.I > 0" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('TNI','MTN') }}</span>
                                    </CCol>
                                    <CCol md="4">
                                        <label class="col-form-label-sm">{{this.getLanguage["MT"]["CTN"]}}<span class="required" /> :</label>
                                        <CInput size="sm" :value="arry_amt.CTN" @change="v => arry_amt.CTN = v" :disabled="arry_amt['TNI'] != dd_mt[dd_mt.length-1].id" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('CTN','CTN') }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol md="4">
                                        <label class="col-form-label-sm">{{this.getLanguage["MT"]["TC"]}}<span class="required" /> :</label>
                                        <swatches :value="arry_amt.TC" @close="TCColorChange" fallback-input-type="color" show-fallback colors="text-advanced" popover-to="left" :disabled="arry_amt['TNI']!= dd_mt[dd_mt.length-1].id"></swatches>
                                        <span class="ErrMsg">{{ ValidationErrMsg('TC','TC') }}</span>
                                    </CCol>
                                    <CCol md="4">
                                        <label class="col-form-label-sm">{{this.getLanguage["MT"]["TBC"]}}<span class="required" /> :</label>
                                        <swatches :value="arry_amt.TBC" @close="TBCColorChange" fallback-input-type="color" show-fallback colors="text-advanced" popover-to="left" :disabled="arry_amt['TNI']!= dd_mt[dd_mt.length-1].id"></swatches>
                                        <span class="ErrMsg">{{ ValidationErrMsg('TBC','TBC') }}</span>
                                    </CCol>
                                    <CCol md="4">
                                        <label class="col-form-label-sm">{{this.getLanguage["MT"]["IP"]}}<span class="required" /> :</label>
                                        <div class="custom-tooltip">
                                            <span :style="getPreviewC(arry_amt['TC'],arry_amt['TBC'])">{{this.getLanguage["MT"]["UN"]}}</span>
                                            <span class="custom-tooltiptext" :style="getPreviewC(arry_amt['TC'],arry_amt['TBC'])">{{this.getLanguage["MT"]["MTS"]}}</span>
                                        </div>
                                    </CCol>
                                </CRow>

                                <CRow>
                                    <CCol md="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MT"]["R"]}}<span class="required" /> :</label>
                                        <textarea vertical="" rows="7" class="form-control form-control-sm" :value="arry_amt.R" @change="TextValueChange('R',$event)" v-shortkey.avoid />
                                        <span class="ErrMsg">{{ ValidationErrMsg('R','R') }}</span>
                                    </CCol>
                                </CRow>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveMemberType()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ this.getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                            <template v-else-if="header == 'AGI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MT"]["BN"]}}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MT"]["MTN"]}}
                                                <i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'IP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MT"]["IP"]}}
                                            </template>
                                            <template v-else-if="header == 'CB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["CB"]}}
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["CT"]}}
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'UB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["UB"]}}
                                            </template>
                                            <template v-else-if="header == 'UTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["UTS"]}}
                                                <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MT"]["TC"]}}
                                            </template>
                                            <template v-else-if="header == 'TBC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MT"]["TBC"]}}
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["MT"]["MTS"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addMemberType()"><span class='plusIcon cil-plus'></span>{{ this.getLanguage["BTN"]["AN"] }}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <label class="searchLabel">{{this.getLanguage["MT"]["BN"]}} :</label>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[1].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[1].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[1].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[1].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[1].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[1].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["MT"]["VIP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vip"
                                            placeholder
                                            v-model="str_FV[2].FV" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["MT"]["VDP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vdp"
                                            placeholder
                                            v-model="str_FV[3].FV" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['MT']['MTL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'AGI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MT"]["BN"]}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MT"]["MTN"]}}
                                        <i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'IP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MT"]["IP"]}}
                                    </template>
                                    <template v-else-if="header == 'CB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["CB"]}}
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["CT"]}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'UB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["UB"]}}
                                    </template>
                                    <template v-else-if="header == 'UTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["UTS"]}}
                                        <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MT"]["TC"]}}
                                    </template>
                                    <template v-else-if="header == 'TBC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MT"]["TBC"]}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'AGI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MT"]["BN"]}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MT"]["MTN"]}}
                                        <i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'IP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MT"]["IP"]}}
                                    </template>
                                    <template v-else-if="header == 'CB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["CB"]}}
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["CT"]}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'UB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["UB"]}}
                                    </template>
                                    <template v-else-if="header == 'UTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["UTS"]}}
                                        <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MT"]["TC"]}}
                                    </template>
                                    <template v-else-if="header == 'TBC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MT"]["TBC"]}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_mtl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_mtl">
                            <td v-for="header in reportHeaders" :key="header">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                    <span id="actionBtnCol">
                                        <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                            <i class="cil-trash" @click="removeMemberType(data)"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-else-if="checkModuleAccess2(constAccessType.delete) && isSENS == 1 && data.AGI != curAGI">
                                            <i class="cil-trash"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                            <i class="cil-color-border" @click="editMemberType(data.I)"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-else-if="checkModuleAccess2(constAccessType.edit) && isSENS == 1 && data.AGI != curAGI">
                                            <i class="cil-color-border"></i>
                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'AGI'">
                                    {{ data.GN }} ({{ data.PC }})
                                </template>
                                <template v-else-if="header == 'TN'">
                                    {{ data.TN }}
                                    <i v-if="data.VIPBAA" class="fa fa-crown" style="color: rgb(201, 84, 90);"></i>
                                    <i v-if="data.VDP" class="fa fa-exclamation-triangle" style="color: #F6BE00;"></i>
                                </template>
                                <template v-else-if="header == 'IP'">
                                    <div class="custom-tooltip">
                                        <span :style="getPreviewC(data.TC, data.TBC)">{{getLanguage["MT"]["U"]}}</span>
                                        <span class="custom-tooltiptext" :style="getPreviewC(data.TC, data.TBC)">{{ data.TN }}</span>
                                    </div>
                                </template>
                                <template v-else-if="header == 'CB'">
                                    {{ data.CB }}
                                </template>
                                <template v-else-if="header == 'CTS'">
                                    {{ formatDateTime(data.CTS,"YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'UB'">
                                    {{ data.UB }}
                                </template>
                                <template v-else-if="header == 'UTS'">
                                    {{ formatDateTime(data.UTS,"YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'TC'">
                                    {{ data.TC }}
                                </template>
                                <template v-else-if="header == 'TBC'">
                                    {{ data.TBC }}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import genericHelper from "@/modules/GenericHelper.js";
    import Loading from 'vue-loading-overlay';
    import { required, minLength, between, url, requiredIf } from 'vuelidate/lib/validators'
    import Swatches from 'vue-swatches';
    import moment from "moment";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import "vue-swatches/dist/vue-swatches.min.css"
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Swatches,
            Loading,
            DateRangePicker,
            draggable
        },
        props: {

        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TI: 0,//Total Items
                int_TP: 0, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }, { F: "CTS", FV: { startDate: "", endDate: "" } }, { F: "VIPBAA" }, { F: "VDP" }], //Filter Value
                arry_amt: [],
                arry_mtl: [],
                dd_agentgroup: [],//agent group option
                dd_agentgroupfs: [],//agent group option
                dd_mt: [],
                constAccessType: constAccessType,
                arry_vip: [],
                arry_vdp: [],
                defaultReportHeaders: ['NO', 'ACT', 'AGI', 'TN', 'IP', 'CB', 'CTS', 'UB', 'UTS', 'TC','TBC'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
            }
        },
        validations: {
            arry_amt: {
                AGIT: { required },
                TNI: { required },
                R: { required },
                CTN: {
                    required: requiredIf(function (vm) {
                        return vm.TNI != null && vm.TNI == 11;
                    }),
                },
                TC: { required },
                TBC: { required },
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'M';
            this.$parent.showActiveMenu = 'M.MTS';
            this.getMemberTypeDefaultValue();
            this.getAgentGroup();
            this.getMTList();
            this.getdd();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess']),
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[1].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[1].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[1].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[1].FV.endDate = "";
                    }
                }
            },
            getdd() {
                this.arry_vip = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['PM']['YES'] }, { id: "0", label: this.getLanguage['PM']['NO'] }];

                this.arry_vdp = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['PM']['YES'] }, { id: "0", label: this.getLanguage['PM']['NO'] }];
            },
            TextValueChange(type, event) {
                if (type == "R") {
                    this.arry_amt.R = event.target.value;
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('MTS', 'M', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            ctrPage(newPage, inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {                                        
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getMTList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getMTList();
                }
            },
            getPreviewC(tc, tbc) {
                var bgColor = tbc;
                var textColor = tc;
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            getMemberTypeDefaultValue() {
                var that = this;
                this.getDataApi(`/api/dd/mtdv/`,
                    function (d, s) {
                        if (s) {
                            that.dd_mt = d.dropdownlist
                        }
                    });
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroupfs.length > 0) {
                                that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            TypeNameChange(id) {
                if (id != undefined && this.arry_amt.I == 0) {
                    var that = this;
                    this.getDataApi(`/api/memtypedv/g/${id}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.$set(that.arry_amt, 'R', d.D.R);
                                that.$set(that.arry_amt, 'TC', d.D.TC);
                                that.$set(that.arry_amt, 'TBC', d.D.TBC);
                            }
                        });
                }
            },
            AgentGroupChangefs(value) {
                if (value != undefined) {
                    this.str_FV[0].FV = value.split("-")[1];
                }
                else {
                    this.str_FV[0].FV = null;
                }
            },
            getMTList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                this.getDataApi(`/api/memtype/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setMTList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setMTList(data) {
                this.arry_mtl = data.Items;                
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            setMT(data) {
                this.arry_amt = data;
                this.bool_isAMV = true;
            },
            addMemberType() {
                this.arry_amt = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    TNI: null,
                    TN: null,
                    R: null,
                    TC: '#000000',
                    TBC: '#FFFFFF',
                    AGI: "",
                    AGIT: null,
                    CTN: null,
                    VIPBAA: false,
                    VDP: false
                };
                this.bool_isAMV = true;
                this.bool_CV = false;
                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.arry_amt.AGIT = this.dd_agentgroup[0].id;
                    }
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.arry_amt[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MT"][langKey]);
                    }
                }

            },
            saveMemberType() {
                this.bool_CV = true;
                this.arry_amt['RS'] = 2;

                for (var d of this.dd_mt) {
                    if (d.id == this.arry_amt['TNI']) {
                        this.arry_amt['TN'] = d.label;
                    }
                }

                if (this.arry_amt['TN'] == 'Custom') {
                    this.arry_amt['TN'] = this.arry_amt['CTN'];
                }

                if (this.arry_amt.AGIT != null && this.arry_amt.AGIT.length > 0) {

                    var agi = this.arry_amt.AGIT.split("-");
                    this.arry_amt.AGI = agi[1];
                }

                this.$v.arry_amt.$touch();
                if (!this.$v.arry_amt.$error) {
                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;

                    this.postDataApi(`/api/memtype/s`, this.arry_amt,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getMTList();
                            }
                        });
                }
            },
            editMemberType(id) {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/memtype/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setMT(d.D);
                            that.bool_isAMV = false;
                            if (that.arry_amt.AGI != 0) {
                                that.arry_amt.AGIT = "3-" + that.arry_amt.AGI;
                            }
                            for (var d of that.dd_mt) {
                                if (d.label == that.arry_amt['TN']) {
                                    that.arry_amt['TNI'] = d.id;
                                }
                            }
                            if (that.arry_amt['TNI'] == null) {
                                that.arry_amt['TNI'] = that.dd_mt.length;
                                that.arry_amt['CTN'] = that.arry_amt['TN'];
                            }
                            that.bool_isAMV = true;
                        }
                    });
            },
            removeMemberType(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: data.I,
                            uts: data.UTS
                        };

                        this.postDataApi(`/api/memtype/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getMTList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            TBCColorChange(value) {
                this.arry_amt.TBC = value;
            },
            TCColorChange(value) {
                this.arry_amt.TC = value;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;
                this.getMTList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[1].FV = {
                    startDate: "",
                    endDate: ""
                };

            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            'arry_amt.VIPBAA': function (newVal, oldVal) {
                if (newVal) {
                    this.arry_amt.VDP = false;
                }
            },
            'arry_amt.VDP': function (newVal, oldVal) {
                if (newVal) {
                    this.arry_amt.VIPBAA = false;
                }
            },
            getLanguage() {
                this.getMTList();
                this.getdd();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/MemberTypeList`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                // hide columns for unauthorized access users
                                if (!(that.checkModuleAccess2(constAccessType.edit) || that.checkModuleAccess2(constAccessType.delete))) {
                                    that.removeDefaultColumn('ACT');
                                    that.removeColumn('ACT');
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/MemberTypeList/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>

<style>
.vue-swatches__trigger {
    width: 170px !important;
    height: 30px !important;
    border-radius: 4px !important;
    outline: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Member/MemberType.vue